import React, {Component} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';

import TotalSearch from './containers/search/totalSearch';
import Journals from './containers/journal/front/journals';
import Journal from './containers/journal/front/journal';
import Resources from './containers/resource/front/resources';
import Resource from './containers/resource/front/resource';
import Scholars from './containers/scholar/front/scholars';
import Scholar from './containers/scholar/front/scholar';
import Departments from './containers/department/front/departments';
import Department from './containers/department/front/department';
import Mypage from './containers/mypage/front/mypage';

import {BASE_PATH} from "./wpconfig";

class WebApp extends Component {
    render() {
        return (
            <>
                <BrowserRouter>
                    <Switch>
                        <Route path={BASE_PATH + 'search/'} component={TotalSearch}/>
                        <Route path={BASE_PATH + 'journals/'} component={Journals}/>
                        <Route path={BASE_PATH + 'journal/'} render={(props) => (
                            <Journal key={props.location.search} {...props}/>
                        )}/>
                        <Route path={BASE_PATH + 'resources/'} component={Resources}/>
                        <Route path={BASE_PATH + 'resource/'} render={(props) => (
                            <Resource key={props.location.search} {...props}/>
                        )}/>
                        <Route path={BASE_PATH + 'scholars/'} component={Scholars}/>
                        <Route path={BASE_PATH + 'scholar/'} render={(props) => (
                            <Scholar key={props.location.search} {...props}/>
                        )}/>
                        <Route path={BASE_PATH + 'departments/'} component={Departments}/>
                        <Route path={BASE_PATH + 'department/'} render={(props) => (
                            <Department key={props.location.search} {...props}/>
                        )}/>
                        <Route path={BASE_PATH + 'mypage/'} component={Mypage}/>
                    </Switch>
                </BrowserRouter>
            </>
        );
    }
}

export default WebApp;
